import React from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';

const CloudSolutionsSlider = () => {
  const [sliderRef] = useKeenSlider(
    {
      loop: true,
      slides: {
        perView: 1,
      },
    },
    [
      (slider) => {
        let timeout;
        let mouseOver = false;

        function clearNextTimeout() {
          clearTimeout(timeout);
        }

        function nextTimeout() {
          clearTimeout(timeout);
          if (mouseOver) return;
          timeout = setTimeout(() => {
            slider.next();
          }, 3500);
        }

        slider.on("created", () => {
          slider.container.addEventListener("mouseover", () => {
            mouseOver = true;
            clearNextTimeout();
          });
          slider.container.addEventListener("mouseout", () => {
            mouseOver = false;
            nextTimeout();
          });
          nextTimeout();
        });
        slider.on("dragStarted", clearNextTimeout);
        slider.on("animationEnded", nextTimeout);
        slider.on("updated", nextTimeout);
      },
    ]
  );

  return (
    <section className="w-full pt-[60px] lg:pt-[90px] bg-white overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
        <div ref={sliderRef} className="keen-slider">

          {/* SLIDE 1 */}
          <div className="keen-slider__slide">
            <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch cursor-grab active:cursor-grabbing">

              {/* Left Image (Flush to edge) */}
              <div className="w-full lg:w-full max-w-[498px] overflow-hidden bg-gray-50">
                <img
                  src="/assets/service-detail/item1.png"
                  alt="Tailored Cloud Solutions"
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>

              {/* Right Content */}
              <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-3">
                  Start with the right foundation
                </p>
                <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-5">
                  Tailored, Growth Driven Cloud Solutions
                </h2>
                <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.7] font-[500]">
                  At Mobikode, our cloud engineering services are built to support real business needs no matter the size or complexity. We work closely with you to simplify the shift to the cloud, sharing our expertise along the way so you always know what’s happening and why. Our goal is to make your cloud journey smooth, secure, and truly future-ready.
                </p>
              </div>

            </div>
          </div>

          {/* SLIDE 2 */}
          <div className="keen-slider__slide">
            <div className="w-full bg-white border border-[#D5DDE8] flex flex-col lg:flex-row items-stretch cursor-grab active:cursor-grabbing">

              {/* Left Image (Flush to edge) */}
              <div className="w-full lg:w-full max-w-[498px] overflow-hidden bg-gray-50">
                <img
                  src="/assets/service-detail/item2.png"
                  alt="Result Driven Approach"
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>

              {/* Right Content */}
              <div className="w-full lg:w-1/2 p-6 sm:p-10 lg:p-14 flex flex-col justify-center text-left">
                <p className="font-graphik text-[14px] sm:text-[16px] font-[500] text-[#ED6800] tracking-wide mb-3">
                  Start with the right foundation
                </p>
                <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] leading-[1.25] tracking-tight mb-5">
                  Result Driven Implementation Approach
                </h2>
                <p className="font-graphik text-[14px] lg:text-[16px] text-[#49577A] leading-[1.7] font-[500]">
                  At Mobikode, we treat cloud engineering as a real partnership, not just a service. We help you move to the cloud in a way that actually makes sense for your business from planning to execution. Our focus is simple: smoother operations, real results, and steady, long-term growth you can measure and feel.
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CloudSolutionsSlider;